import { useCallback, useState } from 'react'
import { useCurrentUserId } from '../contexts/AuthContext'
import { clearRecentSearches, readRecentSearches, rememberSearch } from '../utils/recentSearches'

/** The signed-in user's recent searches (this browser only), with remember and clear. */
export function useRecentSearches() {
  const userId = useCurrentUserId()
  const [saved, setSaved] = useState<{ userId: number | null; list: string[] }>({ userId: null, list: [] })
  // Read straight from storage until this user's list has been changed here.
  const searches =
    saved.userId === userId ? saved.list : userId === null ? [] : readRecentSearches(userId)

  const remember = useCallback(
    (query: string) => {
      if (userId === null) return
      rememberSearch(userId, query)
      setSaved({ userId, list: readRecentSearches(userId) })
    },
    [userId]
  )
  const clear = useCallback(() => {
    if (userId === null) return
    clearRecentSearches(userId)
    setSaved({ userId, list: [] })
  }, [userId])

  return { searches, remember, clear }
}
